export default class SessionStorageHelper {
  public static getRedirect(): string | null {
    const item = window.sessionStorage.getItem(`rin-redirect`);
    if(!item) {
      return null;
    }
    return item;
  }

  public static removeRedirect(): void {
    window.sessionStorage.removeItem(`rin-redirect`);
  }

  public static setRedirect(): void {
    window.sessionStorage.setItem(`rin-redirect`, window.location.href);
  }

  public static getChristmasCalendarSeen(): number {
    const date = window.sessionStorage.getItem(`rin-christmas-calendar-seen`);
    return date ? +date : 0;
  }

  public static removeChristmasCalendarSeen(): void {
    window.sessionStorage.removeItem(`rin-christmas-calendar-seen`);
  }

  public static setChristmasCalendarSeen(): void {
    window.sessionStorage.setItem(`rin-christmas-calendar-seen`, Date.now().toString(10));
  }
}
